import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-family-subcard-info',
  templateUrl: './family-subcard-info.component.html',
  styleUrls: ['./family-subcard-info.component.scss']
})
export class FamilySubcardInfoComponent implements OnInit {
  @Input() familyData: any;
  constructor() { }

  ngOnInit(): void {
  }

}
